export default function QualitySection() {
  return (
    <section className="relative w-full py-28 md:py-36 px-6 md:px-10 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="mb-12">
          <div className="section-divider mb-8"></div>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-light tracking-tight text-foreground-950 mb-8">
            Commitment to Quality
          </h2>
        </div>

        <p className="text-base md:text-lg leading-relaxed text-foreground-700 font-light max-w-3xl mb-20">
          Technical excellence is not a destination but a continuous practice. We invest deeply in the refinement of our engineering processes, the adoption of emerging best practices, and the cultivation of a mindset that values precision, clarity, and long-term thinking.
        </p>

        <div className="space-y-12">
          <div className="flex flex-col md:flex-row gap-6 md:gap-12 items-start border-l-2 border-accent-300 pl-6 md:pl-8">
            <div className="md:w-1/4">
              <p className="text-xs uppercase tracking-widest text-accent-600 font-medium">Engineering Standards</p>
            </div>
            <div className="md:w-3/4">
              <p className="text-base leading-relaxed text-foreground-600 font-light">
                We adopt up-to-date engineering standards and continuously improve our development workflows. Every team member contributes to a shared knowledge base of practices that ensure consistency, reliability, and measurable quality across all projects.
              </p>
            </div>
          </div>

          <div className="flex flex-col md:flex-row gap-6 md:gap-12 items-start border-l-2 border-secondary-300 pl-6 md:pl-8">
            <div className="md:w-1/4">
              <p className="text-xs uppercase tracking-widest text-secondary-600 font-medium">Technology Exploration</p>
            </div>
            <div className="md:w-3/4">
              <p className="text-base leading-relaxed text-foreground-600 font-light">
                The technology landscape evolves rapidly, and staying ahead requires active exploration and experimentation. We dedicate time to evaluating new tools, frameworks, and methodologies, integrating those that demonstrably improve the quality and efficiency of our engineering output.
              </p>
            </div>
          </div>

          <div className="flex flex-col md:flex-row gap-6 md:gap-12 items-start border-l-2 border-accent-300 pl-6 md:pl-8">
            <div className="md:w-1/4">
              <p className="text-xs uppercase tracking-widest text-accent-600 font-medium">Process Evolution</p>
            </div>
            <div className="md:w-3/4">
              <p className="text-base leading-relaxed text-foreground-600 font-light">
                Internal processes are not static documents but living systems that evolve with experience. Through regular retrospectives, peer reviews, and data-driven analysis, we refine how we work to eliminate inefficiencies and amplify what works best.
              </p>
            </div>
          </div>

          <div className="flex flex-col md:flex-row gap-6 md:gap-12 items-start border-l-2 border-secondary-300 pl-6 md:pl-8">
            <div className="md:w-1/4">
              <p className="text-xs uppercase tracking-widest text-secondary-600 font-medium">Future Readiness</p>
            </div>
            <div className="md:w-3/4">
              <p className="text-base leading-relaxed text-foreground-600 font-light">
                Every solution we deliver is built with the future in mind. Through thoughtful abstraction, platform-aware design decisions, and forward-compatible architecture, we ensure that the systems we build today remain relevant and adaptable for the challenges of tomorrow.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}